module.exports = __webpack_public_path__ + "img/06 Aniamtion 3-squashed.d14bb05d.jpg";